// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18VtO","colMin":"styles_colMin__1Do_Z"};